import React,{useEffect,useState} from "react";
import { Avatar, Grid, Typography, Button } from "@material-ui/core";
import { useSelector,useDispatch } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { routePaths } from "../../../config/route-paths";
import { history } from "../../../../helpers/history";
import { useTranslation } from "react-i18next";
import { updateSelectedVal } from "../../../e_layout/e_header/e_profile_dropdown/model/profile-action";

const useStyle = makeStyles((theme) => ({
  buttonStyle: {
    borderRadius: "20px",
    color: theme.palette.ePrimary?.base,
    borderColor:theme.palette.ePrimary?.base,
    "&:hover":{
      backgroundColor:theme.palette.ePrimary?.hover,
      color:theme.palette.eWhite?.base
    }
  },
  blueTextColor: {
    color: theme.palette.ePrimary?.base,
    textTransform:"capitalize"
  },
  blueTextColorEmail:{
    color: theme.palette.ePrimary?.base,
  }
}));

const StyleAvatar = withStyles((theme)=>({
  root: {
    width: "70px !important",
    height: "70px !important",
    background:theme.palette.ePrimary?.base,
  },
}))(Avatar);

export default function CustomerInfo() {
  let classes = useStyle();
  let dispatch = useDispatch();
  let [phoneNo,setPhoneNo]=useState();
  const [name,setName]=useState("")
  const [loggedIn,setLoggedIn]=useState()
  let profileDetails = useSelector((state) => state?.profileDetails);
  const {t:label, ready: labelReady} = useTranslation("label-E_CUSTOMER_PROFILE");
  const {t:labelP, ready: labelPReady} = useTranslation("label-PROFILE_CHANGE_PASSWORD");
  const E_PHONE_NUMBER_EXTENSION = useSelector((state)=>state?.parametersWidgets?.ParameterLookup?.E_PHONE_NUMBER_EXTENSION)
  const bearer = JSON.parse(localStorage.getItem("bearer")); 
  const selectedAcc = JSON.parse(localStorage.getItem("accountSelected")); 
  const [email,setEmail]=useState()
  let accountDetails=useSelector((state)=>state.accountInformation)
  useEffect(()=>{},(profileDetails?.phoneNumber))
  let PRIMARYEMAIL;
  useEffect(()=>{
    const pId = JSON.parse(localStorage.getItem("bearer"))?.personId; 
    if(bearer?.isTenant?.[0] === "Y") {
     setLoggedIn(bearer?.userName);
    }
    if (Array.isArray(accountDetails?.personDetailList)) {
      accountDetails.personDetailList.forEach((element) => {
        let personIdtoCompare;
        if(bearer?.isTenant=="Y"){
          personIdtoCompare=pId
        }else{
          personIdtoCompare=accountDetails.personAcccountDetail.personAccountList[0].personId
        }
     if (element["C1-Person"].personId ==personIdtoCompare) {
       if(Array.isArray(element['C1-Person']["personContactDetail"])){
        PRIMARYEMAIL=(element['C1-Person']["personContactDetail"]?.filter(e=>{
          if(e?.personContactDetail?.personId){
            return e?.personContactDetail?.personId==pId
          }else{
            return e?.personId==pId
          }
        }))
        if(bearer?.isTenant=="Y" &&PRIMARYEMAIL.length>1 ){
          PRIMARYEMAIL = PRIMARYEMAIL?.find(e=>e.contactDetailPrimary=="C1YS" &&e.personContactType=="CELLPHONE")
        }
       }else{
        PRIMARYEMAIL=(element['C1-Person']["personContactDetail"]);
       }
 }
  })
   }else{
     if (accountDetails.personDetailList["C1-Person"].personId === accountDetails.personAcccountDetail.personAccountList[0].personId) {
      if(Array.isArray(accountDetails?.personDetailList['C1-Person']["personContactDetail"])){
        PRIMARYEMAIL=(accountDetails?.personDetailList['C1-Person']["personContactDetail"]?.find(element => element.personContactType=='PRIMARYEMAIL' || "CELLPHONE"));
       }else{
         PRIMARYEMAIL=accountDetails?.personDetailList['C1-Person']["personContactDetail"]
       }
       
   }
   }
   if(PRIMARYEMAIL?.contactDetailValue){
     setEmail(PRIMARYEMAIL?.contactDetailValue)
   }
  },[accountDetails,selectedAcc])


  useEffect(()=>{
    const pId = JSON.parse(localStorage.getItem("bearer"))?.personId; 
    if(Array.isArray(bearer.accountDetails.accountSummary.personDetailList)){
        let selectedAcc = bearer?.accountDetails.accountSummary.personDetailList?.filter(e=>e['C1-Person']['personId']==pId)
        setName(selectedAcc[0]["C1-Person"].personName.entityName)
    }
    else{
      setName(bearer.accountDetails.accountSummary.personDetailList["C1-Person"].personName.entityName ?  bearer.accountDetails.accountSummary.personDetailList["C1-Person"].personName.entityName : "-")
    }
  },[accountDetails,selectedAcc])

  let isTenant = bearer?.isTenant

  let userDetails = useSelector((store)=>store?.profileDetails);
  
  useEffect(()=>{
    if(userDetails?.phoneNumber){

      setEmail(userDetails?.phoneNumber)
    }
  },[userDetails])
  
  return (
    <Grid container justify="center" alignItems="center" spacing={1}>
      <Grid item>
        <StyleAvatar alt="Remy Sharp" src="" />
      </Grid>
        <Grid item xs={12}>
        {
          labelReady ?
          <Typography
            className={classes.blueTextColor}
            align="center"
            variant="h5"
          >
            <b>
              {" "}
              {label? label("E_HI") :<Skeleton/>},&nbsp;
              {name}
            </b>
          </Typography>
          : <Skeleton />
        }
          <Typography align="center" variant="subtitle1" >
            {email}
          </Typography>
          {bearer?.isTenant?.[0] === "Y" && <Typography align="center" variant="body2" >
          {label("E_LOGGEDIN")}<span style={{fontWeight:900}}> {labelP("E_LOGGEDIN_TENANT")} </span> {labelP("E_LOGGEDIN_USING")} - {loggedIn}
          </Typography>}
        </Grid>
     
      {labelReady ? (
        <Grid item>
          <Button
            variant="outlined"
            className={classes.buttonStyle}
            align="center"
            onClick={() => history.push(routePaths.PROFILE,
              dispatch(updateSelectedVal(isTenant=="Y"?1:0)))}
          >
            { isTenant=="Y"?labelP("UPDATE_PASSWORD"):label("E_MANAGE_PROFILE")}
          </Button>
        </Grid>
      ) : (
        <Skeleton />
      )}
    </Grid>
  );
}
